import {take} from 'rxjs/operators';
import {GenericConfig} from '@signature-it/ngx-generic/config';
import {SeoService_Generic, LanguageService,EventBusService, BreadcrumbsService} from '@signature-it/ngx-generic/services';
import {
    NavigationService,
    UtilityService,
    SharedDataService,
    SolrService,
    GroupApiService
} from '@signature-it/ngx-catalogue/services';
import {Group, SolrRequestOptionsDTO} from '@signature-it/ngx-catalogue/models';
import {FlatTreeControl} from '@angular/cdk/tree';
import {
    AfterViewInit,
    Component, DestroyRef,
    EventEmitter,
    inject,
    Input,
    OnInit,
    Output,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import { Observable, Observer} from 'rxjs';
import {MatTreeFlatDataSource, MatTreeFlattener, MatTreeNode} from "@angular/material/tree";
import {TranslateService} from "@ngx-translate/core";
import {Router} from "@angular/router";
import { EventName, EventData } from '@signature-it/ngx-generic/classes';
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
declare let _: any;


interface FlatNode {
    expandable: boolean;
    name: string;
    level: number;
    isLoading: boolean
}
/**
 * @title Tree with dynamic data
 */
@Component({
    selector: 'tree-view',
    templateUrl: './tree-view.component.html',
    styleUrls: ['./tree-view.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class TreeViewComponent implements OnInit, AfterViewInit {

    @Input() standAlone: boolean = false;
    @Output() loadGroup: EventEmitter<any> = new EventEmitter<any>();

    @ViewChild('treeCmp') protected treeCmp;
    kw: string;
    filtersData: any = [];
    queryParams: any = {};
    currentGroup: Group;
    groupsTreeCarriedFilters = GenericConfig.groupsTreeCarriedFilters || [];
    protected eventBusService = inject(EventBusService);
    protected breadcrumbsSvc = inject(BreadcrumbsService);
    treeControl: FlatTreeControl<FlatNode>;
    nodeMap = new Map<number, any>();
    destroyRef = inject(DestroyRef);
    isRootExpanded: boolean;

    private transformer = (node: Group, level: number) => {
        const existingNode = this.nodeMap.get(node['id']);

        if (existingNode) {
            existingNode.count = node.count;
            existingNode.node = node;
            return existingNode;
        }


        const newNode = {
            expandable: !node.isleaf,
            level,
            url: node.getUrl(),
            ...node,
            node,
        };
        this.nodeMap.set(node.id, newNode);
        return newNode;
    };
    treeFlattener;
    dataSource: MatTreeFlatDataSource<Group, any>;
    nodes;
    constructor(public navigationSvc: NavigationService,
                public utilitySvc: UtilityService,
                public sharedData: SharedDataService,
                public router: Router,
                public translateSvc: TranslateService,
                public solrService: SolrService,
                public seoSvc: SeoService_Generic,
                public langSvc: LanguageService,
                public groupSvc: GroupApiService) {
    }


    async ngOnInit() {
        this.initTreeControls();
        if (this.standAlone) {
            const id = await this.groupSvc.getGroupRootId().pipe(take(1)).toPromise();
            if (this.router.url.indexOf('catalogue/group') == -1 && this.router.url.indexOf('taxonomy') == -1) {
                this.showRelevantGroups(new Group({id, isleaf: 0, parent: 0 }), '', {}, this.groupSvc.getGroupTreeOnStandAloneMode());
            }
            this.sharedData.getCurrentGroup.subscribe((group: Group) => {
                if (group) {
                    this.showRelevantGroups(group);
                }
            });
            this.sharedData.clickedFilter.subscribe(filters => {
                if (!_.isEmpty(filters)) {
                    this.filtersData = filters;
                    this.setQueryParams();
                }
            });
        }
        this.eventBusService.on(EventName.EVENTS_TO_COLLAPSED_TREE, completed => {
            this.treeCmp.treeControl.collapseAll();
        }, this.destroyRef);
    }

    ngAfterViewInit() {
        this.initExpandNodeChange();
    }

    initTreeControls() {
        this.treeControl = new FlatTreeControl<FlatNode>(
            node => node.level,
            node => node.expandable
        );
        this.treeFlattener = new MatTreeFlattener(
            this.transformer,
            node => node.level,
            node => node.expandable,
            node => node.children,
        );
        this.dataSource = new MatTreeFlatDataSource(
            this.treeControl,
            this.treeFlattener
        );
    }
    initExpandNodeChange() {
        this.treeCmp.treeControl.expansionModel.changed.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(change => {
            if (change.added && change.added.length) {
                this.eventBusService.emit(new EventData(EventName.OPEN_TREE_VIEW_NODE, true));
                // Perform any desired action with the expanded node
                const node = change.added[0];
                if(!node.isleaf && !node.node.children?.length) {
                    this.getChildren(node).subscribe(tree => {
                        node.node.children = tree;
                        this.dataSource.data = [...this.nodes];
                    })
                }

            }
            // set is root expanded
            let root = this.treeControl?.dataNodes?.[0];
            this.isRootExpanded =  this.treeControl.isExpanded(root);
        });
    }

    openCurrentGroup() {
        if (this.treeCmp && this.currentGroup) {
            const currNode =  this.treeCmp.treeControl.dataNodes.find(node => node.id == this.currentGroup.id);
            if (currNode) {
                this.expandTreeUntil(currNode);
                if (GenericConfig.closeCatalogueTreeOnInit) {
                    if (currNode.isRoot) {
                        this.treeCmp.treeControl.collapse(currNode);
                    } else {
                        if(currNode.isleaf){
                            this.treeCmp.treeControl.collapse(this.findParentNode(this.findParentNode(currNode)));
                        } else{
                            this.treeCmp.treeControl.collapse(this.findParentNode(currNode));
                        }
                    }
                }
            }
        }
    }

    expandTreeUntil(node: MatTreeNode<any>): void {
        let currentNode = node;

        while (currentNode) {
            this.treeCmp.treeControl.expand(currentNode);
            currentNode = this.findParentNode(currentNode);
        }
    }


    findParentNode(node: MatTreeNode<any>): MatTreeNode<any> | null {
        return  this.treeCmp.treeControl.dataNodes.find(n => n.children?.some(c => c['id'] == node['id']))
    }

    treeNodeSelected(event, node) {
        if (this.sharedData.isMobileMode() && GenericConfig.mobileMenuTreeNavigateLeafOnly && !node.isleaf) {
            event.stopPropagation();
            event.preventDefault();
            if (!node.isExpanded) {
                node.expand();
            }
        } else {
            this.loadGroup.emit(node.data);
        }
    }

    getChildren(node: any) {
        return new Observable((observer: Observer<any>) => {
            this.navigationSvc.getNavigation(1, node.id, node.taxonomyUri, node.entityVar).subscribe(
                response => {
                    if (response) {
                        const childTree = this.utilitySvc.find(response['data']['children'], node.id);
                        this.buildTree(childTree);
                        this.loadGroupCount(childTree);
                        observer.next(childTree.children);
                        observer.complete();

                    }
                }
            );
        });
    }

    showRelevantGroups(currentGroup, kw?, filtersData?, onInit?) {
        this.kw = kw;
        this.filtersData = filtersData;
        this.setQueryParams();
        this.currentGroup = currentGroup;
        if (GenericConfig.showFullCatTreeOnNavigate && !onInit ) {
            this.showRelevantGroupsCount(_.cloneDeep(this.groupSvc.groupsTree), kw, filtersData);
            return;

        }
        const self = this;
        this.navigationSvc.getNavigation(1, currentGroup.id, currentGroup.taxonomyUri, currentGroup.entityVar).subscribe(
            response => {
                if (response) {
                    self.showRelevantGroupsCount(response['data'], kw, filtersData);
                }
            }
        );
    }

    showRelevantGroupsCount(tree, kw, filtersData) {
        this.addGroupCount(tree, kw, filtersData).subscribe((tree) => {
            this.initTree([tree]);
            this.buildTree(tree);
        });
    }


    initTree(nodes) {
        this.nodes = nodes;
        this.dataSource.data = nodes;
        this.openCurrentGroup();

    }

    buildTree(tree) {
        const self = this;
        if (_.isArray(tree.children)) {
            if (tree.children.length == 0) {
                delete tree.children;
            } else {
                const field = GenericConfig.closeCatalogueTreeOnInit ? 'isCollapsed' : 'isExpanded';
                if (GenericConfig.showFullCatTreeOnNavigate) {
                    const parentGroupIds = this.groupSvc.getParentGroupIds(this.currentGroup);
                    tree[field] = parentGroupIds.includes(parseInt(tree.id));
                } else {
                    tree[field] = true;
                }
                tree.children.forEach(function (group, index) {
                    if (tree.children[index].isleaf == 0) {
                        tree.children[index].hasChildren = true;
                        self.buildTree(tree.children[index]);
                    } else if (_.isArray(tree.children[index].children)) {
                        delete tree.children[index].children;
                        tree.children[index].hasChildren = false;
                    }
                });
            }
        }
    }

    addGroupCount(tree, kw?, filtersData?): Observable<any> {
        const self = this;
        return new Observable((observer: Observer<any>) => {
            self.getFacetsCount(tree, kw, filtersData).subscribe((facets: any) => {
                if (facets.length && tree) {
                    self.getRecursiveName(tree, facets);
                    observer.next(tree);
                }
            });
        });
    }

    getRecursiveName(tree, facetsData) {
        if (tree.isRoot) {
            const facet = facetsData.find(f => f[0] == tree['id'])
            if(facet) {
                tree['name'] = this.translateSvc.instant(tree['name'].replace(/\(\d+\)\s+/g, ''));
                tree['count'] = facet[1];
                tree['active'] = tree['id'] == this.currentGroup.id;
            }
        }
        if (tree.hasOwnProperty('name')) {
            tree = tree.children;
        }
        for (let i = 0; i < tree.length; i++) {
            let found = false;
            if (tree[i]['name']) {
                tree[i]['name'] = _.unescape(tree[i]['name']);
                tree[i]['name'] = this.translateSvc.instant(tree[i]['name']);
                if (facetsData.length > 0) {
                    tree[i]['name'] = tree[i]['name'].replace(/\(\d+\)\s+/g, '');
                    tree[i]['name'] = `(0) ${tree[i]['name']}`;
                    const facet = facetsData.find(f => f[0] == tree[i]['id'])
                    if(facet) {
                        tree[i]['name'] = tree[i]['name'].replace(/\(\d+\)\s+/g, '');
                        tree[i]['count'] = facet[1];
                        tree[i]['active'] = tree[i]['id'] == this.currentGroup.id;
                        found = true;
                    }
                }
            }
            if (tree[i] && tree[i]['children'] && tree[i]['children'].length) {
                let childrenItems = [];
                tree[i]['children'].map(item => {
                    if (item.ignoreBreadcrumbs) {
                        childrenItems.push(...item.children);
                    } else {
                        childrenItems.push(item);
                    }
                });
                tree[i]['children'] = childrenItems;
                this.getRecursiveName(tree[i]['children'], facetsData)
            }
            if (found == false) {
                tree.splice(i, 1);
                i--;
            }
            if (tree.length == i + 1) {
                // this.orderPipe.transform(tree, 'count', true);
            }
        }
    }

    getFacetsCountFullCatTree(tree, kw?, filtersData?): Observable<any> {
        const self = this;
        return new Observable((observer: Observer<any>) => {
            const solrOptions = new SolrRequestOptionsDTO({
                groupId: tree.taxonomyVar ? tree.id : 1,
                search: kw || '',
                filters: filtersData,
                isLeaf: 0,
                taxonomy: tree.taxonomyVar,
                entityVar: tree.entityVar,
            });
            self.solrService.getSolr(solrOptions).subscribe(
                data => {
                    const solrOptions2 = new SolrRequestOptionsDTO({
                        groupId: self.currentGroup.id,
                        search: kw || '',
                        filters: filtersData,
                        isLeaf: self.currentGroup.isleaf,
                        taxonomy: self.currentGroup.taxonomyVar,
                        entityVar: self.currentGroup.entityVar,
                    });
                    self.solrService.getSolr(solrOptions2).subscribe(data2 => {
                        let filterFacet = {
                            'facet_fields': data2.facet_counts.facet_fields || {},
                            'facet_pivot': data2.facet_counts.facet_pivot || {}
                        };
                        this.sharedData.setFilterFacet.next(filterFacet);
                    });
                    observer.next(data.facet_counts.facet_fields['group_id_is'] || []);
                }
            );
        });
    }

    getFacetsCount(tree, kw?, filtersData?): Observable<any> {
        if (GenericConfig.showFullCatTreeOnNavigate) {
            return this.getFacetsCountFullCatTree(tree, kw, filtersData);
        }
        const self = this;
        return new Observable((observer: Observer<any>) => {
            const solrOptions = new SolrRequestOptionsDTO({
                groupId: self.currentGroup.id,
                search: kw || '',
                filters: filtersData,
                isLeaf: self.currentGroup.isleaf,
                taxonomy: this.currentGroup.taxonomyVar,
                entityVar: this.currentGroup.entityVar
            });
            self.solrService.getSolr(solrOptions).subscribe(
                data => {
                    let filterFacet = {
                        'facet_fields': data.facet_counts.facet_fields || {},
                        'facet_pivot': data.facet_counts.facet_pivot || {}
                    };
                    this.sharedData.setFilterFacet.next(filterFacet);
                    observer.next(data.facet_counts.facet_fields['group_id_is'] || []);
                }
            );
        });
    }

    setQueryParams() {
        this.queryParams = {};
        if (this.kw) {
            this.queryParams['kw'] = this.kw;
        }
        if (this.filtersData && Object.keys(this.filtersData).length && this.groupsTreeCarriedFilters && this.groupsTreeCarriedFilters.length) {
            Object.keys(this.filtersData).forEach(key => {
                if (this.groupsTreeCarriedFilters.indexOf(key) > -1) {
                    this.queryParams[key] = this.filtersData[key];
                }
            });
        }
        this.breadcrumbsSvc.queryParamFilter = this.queryParams;
    }




    public hasChild = (_: number, node: FlatNode) => node.expandable;

    loadGroupCount(tree) {
        this.addGroupCount(tree, this.kw, this.filtersData).subscribe((tree) => {
            this.dataSource.data = [...this.dataSource.data];
        });
    }

}
